import React, { Component } from 'react';
import { connect } from 'react-redux';
// utils
import { Translations, cryptoPass } from '../../utils';
// constant
import { FORM_REFS } from '../../constants';
import { LoginDataBA, LoginDataEN, LoginDataES } from './json_login-in';
import { TermsConditions } from './json_terms-and-conditions';
// restClient
import { aemHostClient, eapiClient } from '../../restClient';
// children
import Checkbox from '../common/Checkbox/Checkbox';
import Dynamicform from '../common/Dynamicform/dynamicForm';
import Modal, { ModalBody, ModalFooter, ModalHeader } from '../common/Modal';
//action Creator
import { logInUser } from '../../actions/auth';
import GDocSOWGuide from '../../assets/images/GDOCS_SOW_Guide.pdf';
import GDocsCustomerGuide from '../../assets/images/GDocsCustomerGuide.pdf';
import { customerIncorrectCredentials, restCustomerIncorrectCredentials, setLanguageFlag, setTranslatedData } from '../layouts/actions/actionCreator';
//style
import './login.css';

class Login extends Component {
  constructor(props) {
    super(props);
    this.state = {
      checkedTerms: false,
      termsAndConditionError: undefined,
      showTermsAndConditionModal: false,
      showForgotPwdModal: false,
      email: '',
      password: '',
      GDocsCustomerGuide: require('../../assets/images/GDocsCustomerGuide.pdf'),
      GDocSOWGuide: require('../../assets/images/GDOCS_SOW_Guide.pdf'),
      hasError: false
    };
  }
  translations = (text) => {
    return Translations(text, this.props.lang.currentLang.lang, this.props.lang.translatedData)
  }
  toggleTermsAndConditionsDialog = () => {
    this.setState({
      showTermsAndConditionModal: false
    })
  }

  toggleForgotPwdDialog = () => {
    this.setState({
      showForgotPwdModal: false
    })
  }

  openTermsAndConditionsDialog = (event) => {
    event.stopPropagation();
    this.setState({
      showTermsAndConditionModal: true
    })
  }

  openForgotPwdDialog = (event) => {
    event.preventDefault();
    this.setState({
      showForgotPwdModal: true,
    })
  }

  _confirmTermsAndConditions = (val) => {
    this.setState({
      checkedTerms: val.target.checked,
      termsAndConditionError: !val.target.checked
    });
  }
  componentWillMount() {
    /* aemHostClient("/aemData/formData/json_log-in")
     .then(({data, status}) => {
       document.title = data.title;
      this.setState({gdocsData: data});
     });*/

    document.title = `${LoginDataEN.title} - ${'HSBC GLCM'}`;
    this.setState({ gdocsData: LoginDataEN });

    /*aemHostClient("/aemData/formData/json_terms-and-conditions")
    .then(({data, status}) => {
      this.setState({modalData: data});
    });*/
    this.setState({ modalData: TermsConditions });

  }

  /* componentDidMount(){
     aemHostClient('/aemData/formData/json_en-gb')
             .then(({data}) => {
               this.props.setTranslatedData(data)
             });
             this.props.setLanguageFlag("true");
   }*/

  componentWillReceiveProps(nextProps) {
    switch (nextProps.lang.currentLang.lang) {
      case 'English':
        this.setState({
          gdocsData: LoginDataEN
        });
        break;
      case 'Spanish':
        this.setState({
          gdocsData: LoginDataES,
          GDocsCustomerGuide: require('../../assets/images/GDocsCustomerGuide.pdf'),
          GDocSOWGuide: require('../../assets/images/GDOCS_SOW_Guide.pdf')
        });
        break;
      case 'Bahasa':
        this.setState({
          gdocsData: LoginDataBA,
          GDocsCustomerGuide: require('../../assets/images/GDocsCustomerGuide.pdf'),
          GDocSOWGuide: require('../../assets/images/GDOCS_SOW_Guide.pdf')
        });
        break;
      default:
        this.setState({
          gdocsData: LoginDataEN,
          GDocsCustomerGuide: require('../../assets/images/GDocsCustomerGuide.pdf'),
          GDocSOWGuide: require('../../assets/images/GDOCS_SOW_Guide.pdf')
        });
    }
  }

  onFormSubmit = async (data) => {
    var payLoad = {};
    if (this.state.checkedTerms) {
      this.setState({ termsAndConditionError: false });
    } else {
      this.setState({ termsAndConditionError: true });
    }

    if (this.state.email === "") {
      this.setState({ inputInValidEmail: true });
    } else {
      this.setState({ inputInValidEmail: false });
    }

    if (this.state.password === "") {
      this.setState({ inputInValidPassword: true });
    } else {
      this.setState({ inputInValidPassword: false });
    }

    if (this.state.email !== "" && this.state.password !== "" && this.state.termsAndConditionError === false) {
      payLoad.username = this.state.email
      payLoad.password = await cryptoPass(this.state.password);

      eapiClient("/customers/login", {
        method: 'POST',
        timeout: 30000,
        data: JSON.stringify(payLoad)
      })
        .then(({ data, status, headers }) => {
          if (status === 200 || status === 201) {
            this.props.restCustomerIncorrectCredentials();
            const tokenHeaders = this.updateHeaders(headers);
            this.setState({
              hasError: false
            })

            this.props.logInUser(true, tokenHeaders.token, tokenHeaders.guid, data.responseData.principal, new Date(), '/case-list');
            aemHostClient('/aemData/formData/json_en-gb')
              .then(({ data: aemResponse }) => {
                this.props.setTranslatedData(aemResponse)
                this.props.history.push(this.state.from || status === 201 ? '/first-time-user' : '/case-list');
              });

            this.props.setLanguageFlag("true");
            window.sessionStorage.setItem("loginPath", '/login')

          }
        })
        .catch((error) => {
          this.props.customerIncorrectCredentials({ customerError: true });
          if (error && error.response && error.response.status === 401) {
            this.setState({
              hasError: true
            });
          }
        });
    }
  }
  updateHeaders(headers) {
    if (headers["amtoken"]) {
      headers["AMToken"] = headers["amtoken"]
      headers["X-HSBC-GUID"] = headers["x-hsbc-guid"]
      document.cookie = "AMToken=" + headers["AMToken"];
      delete headers["amtoken"];
      return { 'token': headers["AMToken"], 'guid': headers["X-HSBC-GUID"] }
    }
    else {
      return headers;
    }
  }
  renderFormGroups() {
    let formData = {};
    const properties = {
      formData,
      editType: 'customer-login',
      pathname: this.props.history.location.pathname
    };
    if (this.state.gdocsData !== undefined) {
      return (
        <Dynamicform
          properties={properties}
          url={FORM_REFS[this.state.gdocsData['par']]}
          getFormData={this.getFormData}
          disableSubmitOnClick={false}
          onFormSubmit={this.onFormSubmit}
          onFormCancel={this.onFormCancel}
          lang={this.props.lang.currentLang.lang}
          translatedData={this.props.lang.translatedData}
        />
      );
    }
  }



  getFormData = (formData) => {
    this.setState({ formData });
  }

  validateInput = (event) => {
    const value = event.target.value;
    // basic input validation
    if (value !== "") {
      this.setInputAsValid(event.target.name);
    } else {
      this.setInputAsInValid(event.target.name, this.props.mandatoryMessage);
    }
  }

  setInputAsValid = (fieldName) => {
    if (fieldName === "email") {
      this.setState({ inputInValidEmail: false });
    } else if (fieldName === "password") {
      this.setState({ inputInValidPassword: false });
    }
  }

  setInputAsInValid = (fieldName, validationMsg) => {
    if (fieldName === "email") {
      this.setState({ inputInValidEmail: true });
    } else if (fieldName === "password") {
      this.setState({ inputInValidPassword: true });
    }
  }

  handleChange = event => {
    this.setState({
      [event.target.id]: event.target.value,
      hasError: false
    });
  }

  handleBlur = event => {
    this.setState({
      [event.target.id]: event.target.value
    });
  }
  render() {
    const { gdocsData, modalData } = this.state;
    return ((gdocsData && modalData !== undefined ?
      <div id="login" className="login">
        <section className="col-md-9 login-documentation">
          <h1 className="h1-font">
            {
              gdocsData !== undefined &&
              Translations(gdocsData['par']['static_text_introTitle']['text'], this.props.lang.currentLang.lang, this.props.lang.translatedData)
            }
          </h1>
          <p className="login-details--description">
            {
              gdocsData !== undefined &&
              Translations(gdocsData['par']['static_text_introDescription']['text'], this.props.lang.currentLang.lang, this.props.lang.translatedData)
            }
          </p>
          <div className="login-column-container">
            <div className="gls-eq-height">
              <div className="login-column">

                <h2 className="login-column--header">
                  {
                    gdocsData &&
                    Translations(gdocsData['par']['info_graphic_informationToHand']['title'], this.props.lang.currentLang.lang, this.props.lang.translatedData)
                  }
                </h2>
                <p className="login-column--text">
                  {
                    gdocsData &&
                    Translations(gdocsData['par']['info_graphic_informationToHand']['text'], this.props.lang.currentLang.lang, this.props.lang.translatedData)
                  }
                </p>
              </div>
            </div>
            <div className="gls-eq-height">
              <div className="login-column ">

                <h2 className="login-column--header">
                  {
                    gdocsData &&
                    Translations(gdocsData['par']['info_graphic_saveAsYouGo']['title'], this.props.lang.currentLang.lang, this.props.lang.translatedData)
                  }
                </h2>
                <p className="login-column--text">
                  {
                    gdocsData &&
                    Translations(gdocsData['par']['info_graphic_saveAsYouGo']['text'], this.props.lang.currentLang.lang, this.props.lang.translatedData)
                  }
                </p>
              </div>
            </div>
            <div className="gls-eq-height">
              <div className="login-column">

                <h2 className="login-column--header">
                  {
                    gdocsData &&
                    Translations(gdocsData['par']['info_graphic_signDocuments']['title'], this.props.lang.currentLang.lang, this.props.lang.translatedData)
                  }
                </h2>
                <p className="login-column--text">
                  {
                    gdocsData &&
                    Translations(gdocsData['par']['info_graphic_signDocuments']['text'], this.props.lang.currentLang.lang, this.props.lang.translatedData)
                  }
                </p>
              </div>
            </div>
            <div className="gls-eq-height1">
              <div className="login-sow">

                <h2 className="login-column--header">
                  {
                    gdocsData &&
                    Translations(gdocsData['par']['info_graphic_signDocuments']['sow-title'], this.props.lang.currentLang.lang, this.props.lang.translatedData)
                  }
                </h2>
                <p className="login-column--text">
                  {
                    gdocsData &&
                    Translations(gdocsData['par']['info_graphic_signDocuments']['sow-text'], this.props.lang.currentLang.lang, this.props.lang.translatedData)
                  }
                </p>
              </div>
            </div>
            <div className="customerGuide">
              <a className="anchorCustomerGuide"
                href={GDocsCustomerGuide}
                rel="noopener noreferrer"
                tabIndex="0"
                target="_blank"
              >
                {
                  gdocsData &&
                  Translations(gdocsData['par']['static_text_customer_guide']['text'], this.props.lang.currentLang.lang, this.props.lang.translatedData)
                }
                <span className="visuallyhidden">{Translations(gdocsData['par']['static_text_customer_guide']['label'], this.props.lang.currentLang.lang, this.props.lang.translatedData)}</span>
              </a>
            </div>

            <div className="customerGuide">
              <a className="anchorCustomerGuide"
                href={GDocSOWGuide}
                rel="noopener noreferrer"
                tabIndex="0"
                target="_blank"
              >
                {
                  gdocsData['par']['static_text_sow_guide']['text']
                }
                <span className="visuallyhidden">{gdocsData['par']['static_text_sow_guide']['label']}</span>
              </a>
            </div>
          </div>
        </section>

        <section className="col-md-3 login-details">
          <p className="login-details--heading">
            {
              gdocsData &&
              Translations(gdocsData['par']['static_text_passwordText']['text'], this.props.lang.currentLang.lang, this.props.lang.translatedData)
            }
          </p>
          {this.state.hasError &&
            <div role="alert" className="gdocs-banner gdocs-banner--alert gdocs-mtop-20" id="Login-Failed">
              <i className="icon gdocs-banner__icon icon-circle-delete-solid "></i>
              <span className="gdocs-banner__content">
                {
                  gdocsData &&
                  Translations(gdocsData.par.text_box_generalInformation.text, this.props.lang.currentLang.lang, this.props.lang.translatedData)
                }
              </span>
            </div>
          }
          <form className="login-details-form">
            <fieldset>
              <legend>Login</legend>
              <label htmlFor="email">
                {
                  gdocsData &&
                  Translations(gdocsData['par']['text_box_emailAddress']['title'], this.props.lang.currentLang.lang, this.props.lang.translatedData)
                }
              </label>
              <input
                type="email"
                name="email"
                id="email"
                onChange={this.handleChange}
                onBlur={this.validateInput}
                aria-describedby="emailAddressError"
              />

              {
                this.state.inputInValidEmail
                  ? (
                    <div className="input-error-msg-section" id="emailAddressError" role="alert">
                      <span className="icon icon-circle-delete-solid"></span>
                      {
                        gdocsData &&
                        Translations(gdocsData['par']['text_box_emailAddress']['shortDescription'], this.props.lang.currentLang.lang, this.props.lang.translatedData)
                      }
                    </div>
                  )
                  : ''
              }

              <label htmlFor="password">
                {
                  gdocsData &&
                  Translations(gdocsData['par']['text_box_password']['title'], this.props.lang.currentLang.lang, this.props.lang.translatedData)
                }
              </label>

              <input
                type="password"
                name="password"
                id="password"
                onChange={this.handleChange}
                onBlur={this.validateInput}
                aria-describedby="passwordError"
              />
              {
                this.state.inputInValidPassword ? (
                  <div className="input-error-msg-section" id="passwordError" role="alert">
                    <span className="icon icon-circle-delete-solid"></span>
                    {
                      Translations(gdocsData['par']['text_box_password']['shortDescription'], this.props.lang.currentLang.lang, this.props.lang.translatedData)
                    }
                  </div>
                ) : ''
              }

              {/*{this.renderFormGroups()}*/}
              <a href="#"
                className="forgot-password"
                id="forgetPassword"
                onClick={this.openForgotPwdDialog}
                tabindex="0">
                {
                  gdocsData &&
                  Translations(gdocsData['par']['static_text_forgottenPasswordLink']['text'], this.props.lang.currentLang.lang, this.props.lang.translatedData)
                }
              </a>
              <div className="checkbox-wrapper">
                <Checkbox
                  onChange={this._confirmTermsAndConditions}
                  name="tnc"
                  value={this.state.checkedTerms}
                  linkText={Translations(gdocsData['par']['checkbox_termsAndConditions']['title'], this.props.lang.currentLang.lang, this.props.lang.translatedData)}
                  lblText={Translations(gdocsData['par']['checkbox_termsAndConditions']["text"], this.props.lang.currentLang.lang, this.props.lang.translatedData)}
                  lblClassName={'login-details-form-terms gls-agree-terms-conditions'}
                  handLinkeClick={this.openTermsAndConditionsDialog}
                  linkClass="gls-terms-condition-link"
                  ariaLabelledby='termsAndConditions'
                  ariaLabelledbytext='agree'
                  ariadescribedby="checkBoxError"
                />
              </div>
              <div className="gdocs-clear-float"></div>
              {
                this.state.termsAndConditionError ? (
                  <div className="input-error-msg-section" id="checkBoxError"
                    role="alert">
                    <span className="icon icon-circle-delete-solid"></span>
                    {
                      Translations(gdocsData['par']['checkbox_termsAndConditions']['shortDescription'], this.props.lang.currentLang.lang, this.props.lang.translatedData)
                    }
                  </div>
                ) : ''
              }

              <input
                type="button"
                disabled={!this.state.checkedTerms}
                aria-describedby="Login-Failed"
                onClick={this.onFormSubmit}
                className={!this.state.checkedTerms ? 'gls-input-btn btn-disable' : 'gls-input-btn'}
                name="supportingDoc"
                value={
                  gdocsData &&
                  Translations(gdocsData['par']['button_logOn']['text'], this.props.lang.currentLang.lang, this.props.lang.translatedData)
                }
              />
              <Modal show={this.state.showForgotPwdModal} onClose={this.toggleForgotPwdDialog} bsClass="delete-group-model">
                <ModalHeader
                  title={Translations(gdocsData['par']['static_text_forgottenPasswordLink']['text'], this.props.lang.currentLang.lang, this.props.lang.translatedData)}
                />
                <ModalBody>
                  <div className="gdoc-modal-separator">
                    {
                      Translations(gdocsData['par']['text_box_generalInformation']['contactText'], this.props.lang.currentLang.lang, this.props.lang.translatedData)
                    }
                  </div>
                </ModalBody>
                <ModalFooter>
                  <div className="delete-group-model--body">
                    <div className="gdocs-float-right">
                      <button
                        className="gdocs-btn-primary"
                        id="forgot-cls-btn"
                        onClick={this.toggleForgotPwdDialog}
                      >
                        {
                          Translations(modalData['par']['button_close']['buttonLabelClose'], this.props.lang.currentLang.lang, this.props.lang.translatedData)
                        }
                      </button>
                    </div>
                    <div className="gdoc-admin-login-clearbth"></div>
                  </div>
                </ModalFooter>
              </Modal>

              {/*<input
          type="checkbox"
          name="{gdocsData && gdocsData['par']['checkbox_termsAndConditions']['termsAndConditions']}"
          id="tnc"
          />*/}
              <Modal show={this.state.showTermsAndConditionModal} onClose={this.toggleTermsAndConditionsDialog} bsClass="delete-group-model">
                <ModalHeader title={Translations(modalData['par']['page_title_mainTitle']['pageHeading'], this.props.lang.currentLang.lang, this.props.lang.translatedData)} />
                <ModalBody>
                  <div className="gdoc-modal-separator">
                    {
                      Translations(modalData['par']['page_title_mainTitle']['descriptionText'], this.props.lang.currentLang.lang, this.props.lang.translatedData)
                    }
                  </div>
                </ModalBody>
                <ModalFooter>
                  <div className="delete-group-model--body">
                    <div className="gdocs-float-right">
                      <button
                        className="gdocs-btn-primary"
                        id="terms-cls-btn"
                        onClick={this.toggleTermsAndConditionsDialog}
                      >
                        {
                          Translations(modalData['par']['button_ok']['buttonLabels'], this.props.lang.currentLang.lang, this.props.lang.translatedData)
                        }
                      </button>
                    </div>
                    <div className="gdoc-admin-login-clearbth"></div>
                  </div>
                </ModalFooter>
              </Modal>

            </fieldset>
          </form>
        </section>
      </div>
      : '')
    )
  }
}

const mapStateToProps = state => {
  return {
    lang: state.lang
  }
}

const mapDispatchToProps = dispatch => {
  return {
    logInUser: (...args) => {
      dispatch(logInUser(...args));
    },
    setTranslatedData: translatedData => {
      dispatch(setTranslatedData(translatedData))
    },
    setLanguageFlag: flag => {
      dispatch(setLanguageFlag(flag));
    },
    customerIncorrectCredentials: flag => {
      dispatch(customerIncorrectCredentials(flag));
    },
    restCustomerIncorrectCredentials: () => {
      dispatch(restCustomerIncorrectCredentials());
    }
  }
}

//export default Login;
export default connect(mapStateToProps, mapDispatchToProps)(Login);



// WEBPACK FOOTER //
// ./src/components/Login/index.js